import React from "react";
import { Link } from "react-router-dom";
import { Star, MapPin } from "lucide-react";
import { CATEGORY_META, fmt } from "@/lib/api";

export default function ListingCard({ listing }) {
  const img = (listing.images && listing.images[0]) || "https://images.unsplash.com/photo-1542051841857-5f90071e7989?w=1200";
  const meta = CATEGORY_META[listing.category] || CATEGORY_META.explore;
  return (
    <Link to={`/listings/${listing.listing_id}`} className="group block" data-testid="listing-card">
      <div className="rounded-2xl bg-card border border-border shadow-[0_10px_30px_-22px_rgba(31,42,68,0.25)] hover:shadow-[0_20px_45px_-22px_rgba(31,42,68,0.35)] hover:-translate-y-0.5 transition-shadow overflow-hidden">
        <div className="relative aspect-[4/3] bg-muted overflow-hidden">
          <img src={img} alt={listing.title} className="h-full w-full object-cover group-hover:scale-[1.03] transition-transform duration-500" loading="lazy" />
          <span className={`absolute top-3 left-3 text-xs font-medium px-2 py-1 rounded-full ${meta.badge}`} data-testid="listing-card-category-badge">
            {listing.category}
          </span>
          {listing.rating_avg > 0 && (
            <span className="absolute top-3 right-3 bg-card text-foreground text-xs font-semibold px-2 py-1 rounded-full inline-flex items-center gap-1">
              <Star className="h-3 w-3 fill-amber-400 text-amber-500" /> {listing.rating_avg?.toFixed(1)}
            </span>
          )}
        </div>
        <div className="p-4">
          <h3 className="font-display text-base md:text-lg font-semibold tracking-tight line-clamp-2">{listing.title}</h3>
          <p className="mt-1 text-sm text-muted-foreground flex items-center gap-1"><MapPin className="h-3.5 w-3.5" /> {listing.location}</p>
          <div className="mt-3 flex items-end justify-between">
            <div>
              <p className="text-xs text-muted-foreground">From</p>
              <p className="text-lg font-semibold" data-testid="listing-card-total-price">{fmt(listing.price?.final ?? listing.base_price)}</p>
              <p className="text-[11px] text-muted-foreground">All-inclusive price</p>
            </div>
            <span className="text-xs text-[hsl(var(--primary))] font-medium">View details →</span>
          </div>
        </div>
      </div>
    </Link>
  );
}
